// Translations for React components. The layout puts the current
// language's `js` strings from config/locales on window.I18N.
//
//   t("dashboard.greeting", { name: "Ann" })  // "Good Evening, Ann"
//
// A key ending in `_html` holds markup for dangerouslySetInnerHTML, so its
// variables are HTML-escaped (a payment method name can't inject markup).
// A missing key shows the key itself, so it is easy to spot.
const strings = () => (typeof window !== "undefined" && window.I18N) || {};

const escapeHtml = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

export const locale = () => strings().locale || "en";

export const t = (key, vars = {}) => {
  const value = key.split(".").reduce((node, part) => (node == null ? node : node[part]), strings().messages);
  if (typeof value !== "string") return key;
  const html = key.endsWith("_html");
  return value.replace(/%\{(\w+)\}/g, (match, name) => {
    if (vars[name] == null) return match;
    return html ? escapeHtml(vars[name]) : String(vars[name]);
  });
};
